import Vue from "vue";
import Router from "vue-router";
import { Trans } from '@/plugins/Translation';
import routes from './routes';
import store from '../store';


Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  base: __dirname,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition){
      return savedPosition
    }
    if(to.name != from.name){
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  if(!store.getters["UserController/isMobile"])
  {
    if(to.name != "ListingDetail" && to.name != "SearchGrid" ){
      store.commit('CategoryController/SET_EMPTY_FILLTER')
    }
  } else{
    if(to.name != "ListingDetail" && to.name != "MobileAdvanceSearch" && to.name != "SearchGrid"){
      store.commit('CategoryController/SET_EMPTY_FILLTER')
    }
  }
  
  if(localStorage && localStorage.getItem('user_profile')){
    var permissionType = JSON.parse(localStorage.getItem('user_profile')).admin_type
  }else{
    var permissionType = { id: 0 }
  }
  document.title = to.meta.title;
  if(to.matched.some(record => record.meta.userAuth)) {
    if(localStorage.getItem('user_profile')){
      Trans.routeMiddleware(to, from, next);
    }else{
      next({ name: ""})
    }
  }else if(to.matched.some(record => record.meta.adminAuth)){
    if(localStorage.getItem('user_profile') && (permissionType.id == 1 || permissionType.id == 2)){
      Trans.routeMiddleware(to, from, next);
    }else{
      next({ name: ""})
    }
  }else{
    Trans.routeMiddleware(to, from, next);
  }
  
});
export default router;